import { render, staticRenderFns } from "./NewsNoData.vue?vue&type=template&id=745103b8&scoped=true"
import script from "./NewsNoData.vue?vue&type=script&lang=js"
export * from "./NewsNoData.vue?vue&type=script&lang=js"
import style0 from "./NewsNoData.vue?vue&type=style&index=0&id=745103b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745103b8",
  null
  
)

export default component.exports